import { api } from '@/lib/api-client.ts'
import {
  IssueTypesDataT,
  IssueTypeT,
} from '@/components/common/menu/lib/types/navigationDataTypes.ts'

export const getCurrStageIssueTypes = async (
  projectStageId: string | undefined | number,
  signal?: AbortSignal,
) => {
  if (!projectStageId) return null
  const response = await api.get(`/project_stages/${projectStageId}/issue_types`, { signal })
  const data: IssueTypesDataT = response.data
  const issues: IssueTypeT[] = data['hydra:member']
  return issues
}
export const currStageIssueTypesQuery = (projectStageId: string | number) => ({
  queryKey: ['currStageIssueTypes', { projectStageId: projectStageId }],
  queryFn: () => getCurrStageIssueTypes(projectStageId),
  staleTime: 1000 * 60,
})
